import { LOGIN_USER_TYPES } from 'constants';

export const avatarNameDisplay = (name) => {
    return `${(name?.first || 'D').charAt(0).toUpperCase()}${(name?.last || 'R').charAt(0).toUpperCase()}`;
};

export const processUserBy = (processUser, loginUser) => {
    if ((processUser.id || processUser._id) === loginUser._id) {
        return 'You';
    }
    return `${processUser?.name?.first || ''} ${processUser?.name?.last || ''}`;
};

export const isAssessorUser = (user) => {
    const roleName = user?.roles?.[0]?.name;
    return roleName?.toUpperCase() === LOGIN_USER_TYPES.ASSESSOR.toUpperCase();
};
